export default "__VITE_ASSET__l4moTAOr__"